module.exports = __webpack_public_path__ + "img/youtiao.6d3784ea.png";